import * as React from 'react';

import {rest} from '@app/components/Api';

import Musthead from '@app/components/UI/MustHead/Musthead';
import {
	howWillIKnowWhenItsTime,
	qualityOfLife,
	painAndAnxiety,
	waitingTooLong,
	weighYourOptionsCarefully,
	whatAboutANaturalDeath, qualityOfLifeScale
} from '@app/components/Pages/HowWillIKnowItsTime/howWillIKnowItsTimeContent';
import RichText from '@app/components/UI/RichText/RichText';
import VideoEmbed from '@app/components/UI/VideoEmbed/VideoEmbed';
import withSeo from '@app/components/LocalCommon/HigherOrderComponents/WithSeo';

interface HowWillIKnowItsTimeContent {
	header: string;
	howWillIKnowWhenItsTime: string | JSX.Element;
	qualityOfLife: string | JSX.Element;
	block2Text: string;
}

const HowWillIKnowItsTime: React.FC = () => {
	const openInNewTab = (arg) => {
		const win = window.open(arg, '_blank');
		win && win.focus();
	};

	React.useEffect(() => {
		try {
			window.scroll({
				top: 0,
				left: 0,
				behavior: 'smooth',
			});
		} catch (error) {
			window.scrollTo(0, 0);
			document.querySelector('#react-app')?.scrollTo(0, 0);
		}
	}, []);

	return (
		<div className="angel-fund">
			<Musthead
				title="How Will I Know It’s Time to Say Goodbye?"
				imageSrc={require('@app/content/dr-mary-lilu.jpg')}
				imageAlt="How will I know it’s time for euthanasia"
			/>
			<RichText
				title="Assessing your pet's quality of life"
				text={howWillIKnowWhenItsTime}
			/>
			<VideoEmbed
				text={qualityOfLifeScale}
			/>
			<RichText
				title="Quality of life"
				text={qualityOfLife}
			/>
			<VideoEmbed
				text={<>Are you having trouble assessing your pet’s quality of life? <br/> Watch this video from Dr. Mary
				Gardner for help.</>}
				videoSrc="https://www.youtube.com/embed/sACwZ_dFmAg?showinfo=0"
			/>
			<RichText
				title="Pain and anxiety"
				text={painAndAnxiety}
			/>
			<RichText
				title="Waiting too long"
				text={waitingTooLong}
			/>
			<RichText
				title="What about a natural death?"
				text={whatAboutANaturalDeath}
			/>
			<RichText
				title="Weigh your options carefully"
				text={weighYourOptionsCarefully}
			/>
			<VideoEmbed
				text="Dr. Dani McVety’s video can answer many questions you may have about your pet’s end of life experience."
				videoSrc="https://www.youtube.com/embed/NRgCGQSYZV0?showinfo=0"
			/>
		</div>
	);
};

export default withSeo(HowWillIKnowItsTime, state => state.howWillIKnowPage, 'howWillIKnowPage', 'how-will-i-know-it-is-time', false);